<div class="pt-3 pl-md-4 mb-6">

  <div class="floating-alert-container">
    <div class="alert alert-success alert-dismissible" role="alert" *ngIf="successMessage">
      {{ successMessage }}
      <button type="button" class="close" (click)="successMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
      <button type="button" class="close" (click)="errorMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="alert alert-info" role="alert" *ngIf="loadingOrgConfig">
      Loading...
    </div>

    <div class="alert alert-info" role="alert" *ngIf="savingOrgConfig">
      Saving...
    </div>
  </div>

  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin">
        Admin
      </a></li>
      <li class="breadcrumb-item"><a routerLink="/gifting-config">
        Gift Center
      </a></li>
      <li class="breadcrumb-item active" aria-current="page">
        Manage Gift Card Sales
      </li>
    </ol>
  </nav>

  <h2>Manage Gift Card Sales</h2>

  <h2 *ngIf="serverError !== null">
    Server Error: {{ serverError }}
  </h2>

  <ng-container *ngIf="(serverError === null) && !loadingOrgConfig">

    <div class="form-group">
      <label for="allow_gift_card_sales">
        Allow customers to purchase gift cards in the Climber App Gift Center?
      </label>
      <div class="row">
        <div class="col-md-6 col-lg-4">
          <select class="custom-select"
                  id="allow_gift_card_sales"
                  name="allow_gift_card_sales"
                  [(ngModel)]="orgConfig.allow_gift_card_sales"
                  (ngModelChange)="unsavedChanges = true"
                  [disabled]="savingOrgConfig || (orgConfig.pos_software === OrgPOSSoftware.none)"
                  [class.disabled]="savingOrgConfig || (orgConfig.pos_software === OrgPOSSoftware.none)">
            <option [ngValue]="false">No</option>
            <option [ngValue]="true">Yes</option>
          </select>
        </div>
      </div>
      <small class="form-text text-muted"
             *ngIf="orgConfig.pos_software !== OrgPOSSoftware.none">
        If enabled, customers will see the option to purchase gift cards in the Climber App.
        <ng-container *ngIf="orgConfig.pos_software === OrgPOSSoftware.square">
          This option will link to your Square ecommerce website.
        </ng-container>
        <br>
        The purchased gift cards will be usable for purchases with your integrated
        {{ getPOSSoftwareDisplay(orgConfig.pos_software) }}
        software, and may also be used for purchases in the Capitan Climber App if "Allow
        {{ getPOSSoftwareDisplay(orgConfig.pos_software) }}
        gift cards to be used for Capitan purchases" is enabled in
        <a routerLink="/organization-settings">Organization Settings</a>.
      </small>
      <div class="alert alert-danger mt-2"
             *ngIf="orgConfig.pos_software === OrgPOSSoftware.none">
        A Point-of-Sale integration (either Square or Lightspeed) must be active in order to sell gift cards in the Climber App Gift Center.
      </div>
      <div class="text-danger">
        {{ errors.allow_printing_gifts }}
      </div>
    </div>

    <ng-container *ngIf="orgConfig.allow_gift_card_sales">

      <ng-container *ngIf="orgConfig.pos_software === OrgPOSSoftware.square">

        <div class="form-group">
          <label for="external_gift_card_purchase_url">
            Square Ecommerce Gift Card Purchase URL
          </label>
          <input type="text" class="form-control"
                 id="external_gift_card_purchase_url"
                 name="external_gift_card_purchase_url"
                 [(ngModel)]="orgConfig.external_gift_card_purchase_url"
                 (ngModelChange)="unsavedChanges = true">
          <div class="form-text text-muted">
            The button to purchase a gift card in the Climber App Gift Center will bring the customer to the Square online gift card purchase page to complete the purchase.
          </div>
          <div class="text-danger">
            {{ errors.external_gift_card_purchase_url }}
          </div>
        </div>

      </ng-container>

      <ng-container *ngIf="orgConfig.pos_software === OrgPOSSoftware.lightspeed">

        <div class="alert alert-info">
          In order to sell gift cards in the Climber App, gift cards must be enabled in your Lightspeed account. Gift cards can be enabled or disabled in the Lightspeed web app by navigating to "Products" &rarr; "Gift cards".
        </div>

        <div class="form-group">
          <div class="row">
            <div class="col-lg-6 col-md-8">
              <label for="max_gift_card_future_delivery_date_days">
                How far in advance can a customer schedule the delivery date?
              </label>
              <div class="input-group">
                <input type="number"
                       min="0" max="366" step="1"
                       id="max_gift_card_future_delivery_date_days"
                       name="max_gift_card_future_delivery_date_days"
                       class="form-control"
                       [(ngModel)]="orgConfig.max_gift_card_future_delivery_date_days"
                       (ngModelChange)="unsavedChanges = true">
                  <div class="input-group-append">
                    <span class="input-group-text">days</span>
                  </div>
              </div>
            </div>
          </div>
          <small class="form-text text-muted">
            Customers may purchase a gift for delivery on a future date (for example, as a birthday present). This setting restricts how far in the future that date may be. If this is set to 0, customers will only be able to purchase gifts for immediate delivery.
          </small>
          <div class="form-text text-danger">
            {{ errors.max_gift_card_future_delivery_date_days }}
          </div>
        </div>

        <div class="form-group row">
          <div class="col-lg-10">
            <label>Terms and Conditions (for the gift giver)</label>
            <app-markdown-editor [id]="'giverTsAndCs'"
                                 [(content)]="orgConfig.gift_card_giver_terms_and_conditions"
                                 (contentChange)="unsavedChanges = true"
                                 [shortEditor]="true"></app-markdown-editor>
            <small class="form-text text-muted">
              This text will be shown alongside a checkbox. The customer buying the gift must agree to the terms and conditions before completing the purchase.
              <br>
              <i>
                Note: these terms do not replace the terms and conditions that are already included on the membership. If the membership has separately configured terms and conditions, the gift giver must agree to both.
              </i>
            </small>
          </div>
          <div class="form-text text-danger">
            {{ errors.gift_card_giver_terms_and_conditions }}
          </div>
        </div>

        <div class="form-group row">
          <div class="col-lg-10">
            <label>Gift Recipient Text</label>
            <app-markdown-editor [id]="'gift_card_recipient_text'"
                                 [(content)]="orgConfig.gift_card_recipient_text"
                                 (contentChange)="unsavedChanges = true"
                                 [shortEditor]="true"></app-markdown-editor>
            <small class="form-text text-muted">
              This text will be shown at the bottom of the email or PDF delivered to the gift recipient.
            </small>
            <button class="btn btn-sm btn-outline-primary mt-1"
                    (click)="openGiftCardRecipientTextPreviewModal()">
              Preview
            </button>
            <div class="form-text text-danger">
              {{ errors.gift_card_recipient_text }}
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="min_gift_card_value">Min Gift Card Value</label>
          <div class="row">
            <div class="input-group col-lg-3 col-md-4 col-sm-5">
              <div class="input-group-prepend">
                <span class="input-group-text">{{ orgConfigService.getCurrencySymbol() }}</span>
              </div>
              <input id="min_gift_card_value"
                     type="number"
                     name="min_gift_card_value"
                     class="form-control"
                     [(ngModel)]="orgConfig.min_gift_card_value"
                     (ngModelChange)="unsavedChanges = true">
            </div>
          </div>
          <div class="form-text text-danger">{{ errors.min_gift_card_value }}</div>
        </div>

        <div class="form-group">
          <label for="max_gift_card_value">Max Gift Card Value</label>
          <div class="row">
            <div class="input-group col-lg-3 col-md-4 col-sm-5">
              <div class="input-group-prepend">
                <span class="input-group-text">{{ orgConfigService.getCurrencySymbol() }}</span>
              </div>
              <input id="max_gift_card_value"
                     type="number"
                     name="max_gift_card_value"
                     class="form-control"
                     [(ngModel)]="orgConfig.max_gift_card_value"
                     (ngModelChange)="unsavedChanges = true">
            </div>
          </div>
          <div class="form-text text-danger">{{ errors.max_gift_card_value }}</div>
          <small class="form-text text-muted">
            These settings should match the minimum and maximum gift card values configured in your Lightspeed account.
          </small>
        </div>

        <div class="row">
          <div class="form-group col-lg-6 col-md-8">
            <label for="gift_card_tax_rate_id">Tax Rate</label>
            <div class="float-right">
              <a href="#"
                 (click)="$event.preventDefault();loadTaxRates();">
                Refresh Tax Rates
              </a>
              |
              <a routerLink="/tax-rates-config" target="_blank">
                Configure Tax Rates
              </a>
            </div>
            <select id="taxRateSelectLoading" class="custom-select" name="tax_rate"
                    *ngIf="loadingTaxRates" disabled>
              <option>Loading...</option>
            </select>
            <select id="gift_card_tax_rate_id"
                    class="custom-select"
                    name="gift_card_tax_rate_id"
                    *ngIf="!loadingTaxRates"
                    [(ngModel)]="orgConfig.gift_card_tax_rate_id"
                    (ngModelChange)="unsavedChanges = true">
              <option *ngIf="taxRateRemoved(orgConfig.gift_card_tax_rate_id)"
                      [ngValue]="orgConfig.gift_card_tax_rate_id">
                {{ orgConfig.gift_card_tax_rate_name }} (Removed)
              </option>
              <option *ngFor="let taxRate of taxRateList"
                      [ngValue]="taxRate.id">
                {{ taxRate.name }} - {{ taxRate.rate_percent }}%
              </option>
            </select>
            <div class="form-text text-danger">{{ errors.gift_card_tax_rate_id }}</div>
          </div>
        </div>

      </ng-container>

    </ng-container>

    <button class="btn btn-outline-primary"
            [disabled]="savingOrgConfig || !unsavedChanges"
            [class.disabled]="savingOrgConfig || !unsavedChanges"
            (click)="saveOrganizationConfig()">
      Save Changes
    </button>

  </ng-container>

</div>
